import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const FormCustomLayoutWidget: WidgetRegistryEntry = {
  name: "FormCustomLayout",
  component: () => import("./form-custom-layout-widget.component").then((m) => m.FormCustomLayoutWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.FormCustomLayoutWidgetConfiguration)
};
